import React from 'react';
import '../common.scss';
import { useCustomComponent } from '@/hooks';

export interface InputProps {
  id?: string;
  name: string;
  type?: 'text' | 'email' | 'password' | 'tel' | 'url' | 'number';
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  className?: string;
  'aria-label'?: string;
  'aria-describedby'?: string;
}

const InputComponent: React.FC<InputProps> = ({
  id,
  name,
  type = 'text',
  placeholder = '',
  required = false,
  disabled = false,
  value = '',
  onChange,
  onBlur,
  onFocus,
  className = '',
  ...ariaProps
}) => {
  return (
    <input
      type={type}
      id={id}
      name={name}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      value={value}
      autoComplete="off"
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      className={`peptalk-form-element peptalk-input ${className}`.trim()}
      {...ariaProps}
    />
  );
};

export const Input: React.FC<InputProps> = (props: InputProps) => {
  const Component = useCustomComponent({
    componentName: 'Input',
    Component: InputComponent,
  });

  return <Component {...props} />;
};
